// import { bizEdit, findBaseBizOpInfoById, findCasesById, saveCases, updateCases } from "@/services/custom";
import { getNowUserInfo } from "@/utils/common";
import { Button, Form, Input, message } from "antd";
import { isFunction } from "lodash-es";
import { useEffect, useRef, useState } from "react";
import {baseURL} from "@/api";
import {
  bizEdit,
  findBaseBizOpInfoById,
  findCasesById,
  saveCases,
  updateCases
} from "@/services/kuAccount.ts";

// 案例名称
export const ModalDesignNameDom = (props: any) => {
  const { bizId, listRef, onUpdate, fn ,moaFlag} = props;
  const formRef = useRef<any>();
  const [caseName, setCaseName] = useState('');
  const [caseId, setCaseId] = useState<any>();

  useEffect(() => {
    findBaseBizOpInfoById({ data: { id: bizId } }).then((resp: any) => {
      if (resp[0]) {
        // console.log("案例名称-获取caseId:::",resp[0].caseId);
        resp[0].caseId && setCaseId(resp[0].caseId);
        resp[0].caseId && findCase(resp[0].caseId);
      }
    });
  }, []);

  // 获取案例名称
  const findCase = (caseId: any) => {
    findCasesById({ params: { id: caseId } }).then((res: any) => {
      // console.log("案例名称-获取案例名称:::",res?.name);
      setCaseName(res?.name);
      setCaseId(caseId);
      formRef.current.setFieldsValue({ caseName: res?.name });
    }).catch((resp: any) => {
      setCaseId(undefined);
    });
  };
  // 编辑案例
  const updateCase = () => {
    updateCases({
      data: {
        id: caseId, //案例ID
        name: caseName, //案例名称
        sourceType: 'crm', //来源类型
      }
    }).then((res: any) => {
      // console.log('updateCase:::',res);
      message.success('编辑成功');
      isFunction(fn) && fn();
    });
  };
  // 创建案例
  const createCase = () => {
    const _relativeAccount = getNowUserInfo('workNumber');
    const _deptCode = getNowUserInfo('deptCode');
    const _companyCode = getNowUserInfo('company');
    const _positionCode = getNowUserInfo('postCode');
    saveCases({
      data: {
        name: caseName, //案例名称
        sourceType: 'crm', //来源类型
        dashBoardUsersList: [
          {
            workNumber: _relativeAccount, //人员工号
            deptCode: _deptCode, //部门code
            companyCode: _companyCode, //人员所属公司code
            posCode: _positionCode, //职位code
            userResType: 'principal', //职责类型  principal 负责人、member 成员
          },
        ],
      }
    }).then((res: any) => {
      message.success('创建成功');
      if (res) {
        setCaseId(res);
        bizEdit({
          data: { id: bizId, caseId: res }
        });
        setCaseName(caseName)
        listRef && listRef.current.reload();
        isFunction(onUpdate) && onUpdate(res);
        isFunction(fn) && fn();
      }
    });
  };

  return (
      <Form layout="inline" style={{ padding: '15px' }} ref={formRef}>
        <Form.Item label="案例名称" name="caseName">
          <Input
              disabled={!(moaFlag == 'pri')}
              value={caseName}
              onChange={(e) => {
                setCaseName(e.target.value);
              }}
              onBlur={() => {
                if (!!caseName && caseId) {
                  updateCase();
                } else if (caseName) {
                  createCase();
                }
              }}
          />
        </Form.Item>
        <Button
            disabled={!(caseId && caseName)}
            onClick={() => {
              // window.open(`/micro/design/#/micro/design/customer/${caseId}`);
              window.open(baseURL.replace('/api', '') + `design/#/design/customer/${caseId}?bizOpId=${bizId}`);
            }}
        >
          查看案例
        </Button>
      </Form>
  );
};
